export default function isIndexStock(stock) {
  if (stock.symbolType) return stock.symbolType === 'index'
  return [
    '000001.SH',
    '399001',
    '399006',
    'HSI',
    'HSCEI',
    'HSCCI',
    '.DJI',
    '.IXIC',
    '.INX'
  ].includes(stock.symbol)
}
